/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ClientEvents from '../../Game/Integrations/ClientEvents';
import ChildComponent from '../../Utility/Component/ChildComponent';
import InjectableComponent from '../../Utility/Component/ComponentReference/InjectableComponent';
import CLog, { LogTypes } from '../../Utility/ComponentLogger';
import Decorators from '../../Utility/Decorators';
import { ccTouchEvent, ccTouchEventHelper } from '../../Utility/TouchEvent';
import Communicator from '../Communicator';
import ErrorForcer from './ErrorForcer';
import { ErrorPrompt } from './ErrorPrompt';
import IErrorParams from './IErrorParams';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class ErrorDef extends ChildComponent<ErrorForcer> implements IErrorParams
{
    @property
    protected errorCode: string = 'WALLET_ERROR';

    @property([cc.String])
    public prompts: string[] =
    [
        ErrorPrompt.ExitToLobby.toString()
    ];

    @property
    public gameLock: string = 'Unlocked';

    @property
    public textCode: string = '1';

    private _clientEventsRef: InjectableComponent<ClientEvents> = new InjectableComponent();
    private _communicatorRef: InjectableComponent<Communicator> = new InjectableComponent();

    public silentRetry: number = 0;
    public notifyRetry: number = 0;

    public traceId?: string;
    public behavior?: string;

    public walletError?: string;
    public rgsData?: string;

    public handlePrompt?: (prompt: string, options: any, buttonIndex: number) => number = null;

    private _target: cc.Node = null;

    protected setContexts(): void
    {
        super.setContexts();
        this._clientEventsRef.SetContext(ClientEvents);
        this._communicatorRef.SetContext(Communicator);
    }

    protected start(): void
    {
        super.start();

        this.updateLabel();
        if (CC_EDITOR) { return; }

        this.handlePrompt = this._communicatorRef.WithValue(communicator => communicator.HandlePrompt, null);
    }

    private updateLabel(): void
    {
        const label: cc.Label = this.getComponentInChildren(cc.Label);
        if (!label) { return; }
        label.string = this.node.name;
    }

    protected onDestroy(): void
    {
        this.unbindTarget(this._target);
        super.onDestroy();
    }

    public BindToTarget(target: cc.Node): void
    {
        if (this._target)
        {
            this.unbindTarget(target);
        }
        this._target = target;
        target.on(ccTouchEventHelper.GetEventName(ccTouchEvent.TOUCH_END), this.executeHandler);
    }

    private unbindTarget(target: cc.Node): void
    {
        if (target == null) { return; }
        target.off(ccTouchEventHelper.GetEventName(ccTouchEvent.TOUCH_END), this.executeHandler);
    }

    @Decorators.BindThis()
    private executeHandler(): void
    {
        this._clientEventsRef.WithValue(clientEvents =>
            {
                clientEvents.ReportError(this.errorCode, this);
            }, () => CLog.error('No client events ref.', this, LogTypes.Configuration));
    }
}
